import { jsxs, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Button } from "../Components/ui/button.js";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "../Components/ui/tooltip.js";
import { cn } from "../lib/utils.js";
const Actions = ({ className, children, ...props }) => /* @__PURE__ */ jsx("div", { className: cn("tw:inline-flex tw:items-center tw:gap-2", className), ...props, children });
const Action = ({ tooltip, children, label, className, tooltipOpen, ...props }) => {
  const [hovered, setHovered] = useState(false);
  const isOpen = tooltipOpen || hovered;
  const button = /* @__PURE__ */ jsxs(
    Button,
    {
      className: cn(
        "tw:relative tw:!size-6 tw:cursor-pointer tw:rounded-[8px] tw:bg-transparent tw:!p-0 tw:text-current tw:hover:bg-transparent tw:[&_svg]:!size-4",
        className
      ),
      type: "button",
      variant: "ghost",
      onMouseEnter: () => setHovered(true),
      onMouseLeave: () => setHovered(false),
      ...props,
      children: [
        children,
        /* @__PURE__ */ jsx("span", { className: "tw:sr-only", children: label || tooltip })
      ]
    }
  );
  if (tooltip) {
    return /* @__PURE__ */ jsx(TooltipProvider, { delayDuration: 200, children: /* @__PURE__ */ jsxs(Tooltip, { open: isOpen, children: [
      /* @__PURE__ */ jsx(TooltipTrigger, { asChild: true, children: button }),
      /* @__PURE__ */ jsx(TooltipContent, { side: "bottom", children: /* @__PURE__ */ jsx("p", { children: tooltip }) })
    ] }) });
  }
  return button;
};
export {
  Action,
  Actions
};
//# sourceMappingURL=actions.js.map
